import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const FoerderZielenAbschlussStartUp: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Beitrag zu den angestrebten Förderzielen" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default FoerderZielenAbschlussStartUp;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0209365699_ativer_Startups_Und_Scaleups,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0013597015_erlassung_Und_Neuansiedelung,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0251615582_s_Startup_Oekosystems_Hessen,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucFoerderZielenAbschlussStartUp = () => {
	return concat(formStruc());
};
